import { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import addDays from 'date-fns/addDays';

import { isEmpty } from 'lodash';
import { connect, useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
// @ts-ignore
import { DateRange } from 'react-date-range';

import {
  DateType,
  FilterType,
  getDashboarReports,
  getTrendsReports,
  IDashboardReportState,
  IReportsRequest,
setDashboardReportsRequest,
} from '@store/slices';

import { Select } from 'antd';

import { DEFAULT_MEDIA_POINT } from '@share/constants';

import { Range, RangeFocus } from 'react-date-range';
import { CloseSvg } from '@share/assets';
import { BlueButton } from '@share/components';
import { ILoginState } from '@share/store/slices';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

import { DashboardReportFiltersButtons } from '../dashboard-report-filters-buttons';

import './style.scss';
import { MEMBER_STATUS } from '@constants';

const mobileMonthCount = 12;
const fullMonthCount = 2;
const isStart = 0;
const defaultRange = 0;
const oneItem = 1;
const seven = 7;
const focusZIndex = 4;
const blurZIndex = 1;

interface IMapDispatchToProps {
  getDashboarReports: () => void;
setDashboardReportsRequest: (request: IReportsRequest) => void;
  getTrendsReports: () => void;
}

interface IProps extends IMapDispatchToProps {
  isV2: boolean;
  activeTab: string;
  filterValue: string;
  setActiveTab: (tab: string) => void;
  setFilterValue: (filterType: string) => void;
}

function DashboardReportFiltersComponent(props: IProps) {
  const [focusedRange, setFocusedRange] = useState([defaultRange, isStart]);
  const [isFocused, setIsFocused] = useState(false);
  const [isEndDateSelected, setIsEndDateSelected] = useState(true);
  const [isInitial, setIsInitial] = useState(false);

  const { activeTab, setDashboardReportsRequest, getDashboarReports, getTrendsReports, setActiveTab, setFilterValue, filterValue } = props;

  const { request } = useSelector((state: { dashboardReportsStore: IDashboardReportState }) => state.dashboardReportsStore);
  const { account } = useSelector((state: { loginStore: ILoginState }) => state.loginStore);

  const period = request?.dateType;
  const fromDate = request?.fromDate;
  const toDate = request?.toDate;

  const locale = account?.locale;

  const isCustomRange = useMemo(() => period === DateType.CUSTOM_RANGE, [period]);
  const isMobile = document.body.offsetWidth <= DEFAULT_MEDIA_POINT;
  const isMobileHeader = document.body.offsetWidth <= 1200;

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
    const newRequest: IReportsRequest = { ...request, filterType: FilterType.ALL };
      dispatch(setDashboardReportsRequest({ ...newRequest }));
    }
  },[])
  useEffect(() => {
    if (!isCustomRange) {
      if (props.isV2) {
        getTrendsReports();
      }
      else {
        getDashboarReports();
      }
    }
  }, [request]);

  const handleFilter = (filterType: string) => {
    setFilterValue(filterType);
    const newRequest: IReportsRequest = { ...request, filterType };
    setDashboardReportsRequest({ ...newRequest });
  };
  const updatePeriod = (dateType: DateType) => {
    const newRequest: IReportsRequest = { ...request, dateType, filterType: filterValue };
    if (dateType !== DateType.CUSTOM_RANGE) {
      newRequest.fromDate = undefined;
      newRequest.toDate = undefined;
    }
    setDashboardReportsRequest({ ...newRequest });
  };

  const updateDate = (ranges: any): void => {
    const range = ranges as { selection: Range };

    setIsInitial(false);

    if (range.selection) {
      const startDate = new Date(
        range.selection.startDate?.getFullYear() as number,
        range.selection.startDate?.getMonth() as number,
        range.selection.startDate?.getDate() as number,
      );

      let endDate = new Date(
        range.selection.endDate?.getFullYear() as number,
        range.selection.endDate?.getMonth() as number,
        range.selection.endDate?.getDate() as number,
      );

      if (!isEndDateSelected && startDate.toString() === endDate.toString()) {
        endDate = addDays(new Date(startDate), seven);
      }

      const newRequest: IReportsRequest = { ...request };
      newRequest.fromDate = moment(startDate).format('MM/DD/yyyy');
      newRequest.toDate = moment(endDate).format('MM/DD/yyyy');

      setDashboardReportsRequest({ ...newRequest });
    }
  };

  const onRangeFocusChange = (focusedRange: RangeFocus): void => {
    setFocusedRange(focusedRange);
    setIsEndDateSelected(!focusedRange[oneItem]);
  };

  const blur = (): void => {
    if (isFocused) {
      setIsFocused(false);
      setIsEndDateSelected(true);
      setFocusedRange([defaultRange, isStart]);
    }
  };

  const setInitialValues = (): void => {
    blur();
  };

  const onDone = (): void => {
    if (props.isV2) {
      getTrendsReports();
    }
    else {
      getDashboarReports();
    }
    blur();
  };

  const focus = () => {
    if (!isFocused) {
      setIsFocused(true);
    }
  };

  const selectionRange = {
    startDate: !isEmpty(fromDate) ? moment(fromDate, 'MM/DD/yyyy').toDate() : moment().toDate(),
    endDate: !isEmpty(toDate) ? moment(toDate, 'MM/DD/yyyy').toDate() : moment().toDate(),
    key: 'selection',
  };

  const generalBorderRadius: any = account?.generalBorderRadius ? account?.generalBorderRadius : null;
  const style = !isEmpty(generalBorderRadius) ? { borderRadius: generalBorderRadius } : {};  

  const renderActions = (display: boolean) => {
    if (!display) {
      return null;
    }

    return (
      <div className="dasshboard-reports-filters-wrapper__actions-container">
        <div className="dasshboard-reports-filters-wrapper__actions">
          <Select value={period} style={{ height: '32px', marginTop: '7px', marginBottom: '7px' }} onChange={(v) => updatePeriod(v)}>
            <Select.Option value={DateType.LAST_7}>
              <FormattedMessage id="LAST_7" />
            </Select.Option>

            <Select.Option value={DateType.LAST_30}>
              <FormattedMessage id="LAST_30" />
            </Select.Option>

            <Select.Option value={DateType.LAST_90}>
              <FormattedMessage id="LAST_90" />
            </Select.Option>

            <Select.Option value={DateType.CUSTOM_RANGE}>
              <FormattedMessage id="CUSTOM_RANGE" />
            </Select.Option>
          </Select>

          {isCustomRange && (
            <div
              className={`date-picker__wrapper ${isFocused && toDate ? 'selected' : ''} ${isFocused ? 'open' : ''}`}
              onClick={focus}
              style={{ ...style, zIndex: isFocused ? focusZIndex : blurZIndex }}
            >
              <div className="date-picker__left">
                <div className="date-picker__icon">
                  <FontAwesomeIcon icon={faCalendarAlt} />
                </div>
              </div>
              <div className="date-picker__right">
                <div className="date-picker__header">
                  {isFocused ? (
                    !isInitial && fromDate ? (
                      <span className="date-picker__date">
                        {moment(fromDate, 'MM/DD/yyyy').format('DD MMM yyyy')}
                      </span>) : (
                      <FormattedMessage id="select.date" />)
                  ) : (
                    <>
                      {fromDate && toDate && !isInitial ? (
                        <>
                          <span className="date-picker__date">
                            {moment(fromDate, 'MM/DD/yyyy').format('DD MMM yyyy')} -{' '}
                            {moment(toDate, 'MM/DD/yyyy').format('DD MMM yyyy')}
                          </span>
                        </>
                      ) : (
                        <FormattedMessage id="select.date" />
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="date-picker__dropdown" style={{ display: isFocused ? 'block' : 'none' }}>
            <div className="date-picker__close-icon" onClick={setInitialValues}>
              <CloseSvg />
            </div>
            <div className={`date-picker__picker ${toDate ? '' : 'show-checkout'}`}>
              <div className="date-picker__picker-wrapper">
                <DateRange
                  editableDateInputs={false}
                  months={isMobile ? mobileMonthCount : fullMonthCount}
                  direction={isMobile ? 'vertical' : 'horizontal'}
                  locale={locale}
                  onChange={updateDate}
                  moveRangeOnFirstSelection={false}
                  monthDisplayFormat="MMMM, yyyy"
                  ranges={[selectionRange]}
                  weekStartsOn={0}
                  weekdayDisplayFormat="EEEEEE"
                  minDate={moment().add(-100, 'years').toDate()}
                  maxDate={moment().toDate()}
                  focusedRange={focusedRange as RangeFocus}
                  onRangeFocusChange={onRangeFocusChange}
                />
              </div>
            </div>
            <div className={`date-picker__footer`}>
              <BlueButton onClick={onDone}>
                <FormattedMessage id="done" />
              </BlueButton>
            </div>
          </div>

          {isFocused && <div className="date-picker__fixed-bg" />}
        </div>
      </div>
    );
  }
  const renderFilters = (display: boolean) => {
    if (!display) {
      return null;
    }

    return (
      <div className="dasshboard-reports-filters-wrapper__actions-container">
        <div className="dasshboard-reports-filters-wrapper__actions">
          <Select value={filterValue} style={{maxWidth: '110px' }} onChange={(filterType) => handleFilter(filterType as string)}          >
            <Select.Option value={FilterType.ALL}>
              <FormattedMessage id="all" />
            </Select.Option>
            <Select.Option value={FilterType.HOTELS}>
              <FormattedMessage id="hotels" />
            </Select.Option>

            <Select.Option value={FilterType.CARS}>
              <FormattedMessage id="Cars" />
            </Select.Option>

          </Select>
        </div>
      </div>
    );
  }

  return (
    <div className="dasshboard-reports-filters-wrapper" style={{ flexDirection: 'column', width: '100%', gap: '0px' }}>
      <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <ul className="nav nav-pills-shadow nav-responsive w-100">
          <li className="nav-item">
            <a
              className={`nav-link mb-0 ${activeTab === 'summary' && MEMBER_STATUS.ACTIVE}`}
              onClick={() => setActiveTab('summary')}
            >
              <FormattedMessage id="summary" />
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link mb-0 ${activeTab === 'top_destinations' && MEMBER_STATUS.ACTIVE}`}
              onClick={() => setActiveTab('top_destinations')}
            >
              <FormattedMessage id="top.destinations" />
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link mb-0 ${activeTab === 'top_travelers' && MEMBER_STATUS.ACTIVE}`}
              onClick={() => setActiveTab('top_travelers')}
            >
              <FormattedMessage id="top.travelers" />
            </a>
          </li>
          <li className="nav-item ms-auto">
          <DashboardReportFiltersButtons activeTab={activeTab} />
          </li>
        </ul>
      </div>
      <hr style={{ width: '-webkit-fill-available' }} />           

      <div className="dashboard-report-header-filter d-flex justify-content-between align-items-center flex-wrap gap-3">
        <div className='dashboard-report-header-filter-left d-flex align-items-center gap-1 flex-wrap'>
          <span className='text-dark'>Filter By Booking Type</span>
          {renderFilters(!isMobileHeader)}
      </div>
        <div className='dashboard-report-header-filter-right d-flex align-items-center gap-1 flex-wrap'>
          <span className='text-dark'>Filter By Date</span>
          {renderActions(!isMobileHeader)}
      </div>
    </div>
    </div>
  );
}


const mapDispatchToProps: IMapDispatchToProps = {
  getDashboarReports,
  setDashboardReportsRequest,
  getTrendsReports
};

export const DashboardReportFilters = connect(
  null,
  mapDispatchToProps,
)(DashboardReportFiltersComponent);
